/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { BaseCommentBaseWithNormalReplies } from './BaseCommentBaseWithNormalReplies';
import { InlineFeedbackExtra } from './InlineFeedbackExtra';
const InlineFeedbackCommentBaseParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(BaseCommentBaseWithNormalReplies, InlineFeedbackExtra);
export class InlineFeedbackCommentBase extends InlineFeedbackExtra {
    static decode(input) {
        return InlineFeedbackCommentBaseParser.decode(input).map(res => new InlineFeedbackCommentBase(res));
    }
    static unsafeDecode(input) {
        return InlineFeedbackCommentBase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return InlineFeedbackCommentBaseParser.encode(data);
    }
    static schema() {
        return InlineFeedbackCommentBaseParser.schema();
    }
}
